(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["influencers-choice"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var X = [0, 0.8, 1.33, 1.72];
    var S = [1, 0.8, 0.67, 0.57];
    var O = [1, 1, 0.5, 0.38];

    function init(root) {
      if (root.dataset.ifcReady) return;
      var stage = root.querySelector('[data-ifc-stage]');
      if (!stage) return;
      root.dataset.ifcReady = 'true';

      var track = root.querySelector('[data-ifc-track]');
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ifc-card]'));
      var prev = root.querySelector('[data-ifc-prev]');
      var next = root.querySelector('[data-ifc-next]');
      var active = Math.floor((cards.length - 1) / 2);
      var startX = null;
      var dragged = false;

      function pauseAll(except) {
        cards.forEach(function (card) {
          if (card === except) return;
          var video = card.querySelector('[data-ifc-video]');
          var button = card.querySelector('[data-ifc-play]');
          if (video && !video.paused) video.pause();
          card.dataset.playing = 'false';
          if (button) {
            button.setAttribute('aria-pressed', 'false');
            button.setAttribute('aria-label', 'Play video');
          }
        });
      }

      function render() {
        var total = cards.length;
        if (!total) return;

        cards.forEach(function (card, i) {
          // Circular positioning: the first and last cards are neighbours.
          var d = i - active;
          if (d > total / 2) d -= total;
          if (d < -total / 2) d += total;

          var a = Math.abs(d);
          var sign = d < 0 ? -1 : 1;
          var hidden = a > 3;
          var idx = hidden ? 3 : a;
          var x = hidden ? sign * 1.95 : sign * X[idx];
          card.style.setProperty('--x', x);
          card.style.setProperty('--s', hidden ? 0.5 : S[idx]);
          card.style.setProperty('--o', hidden ? 0 : O[idx]);
          card.style.setProperty('--z', 10 - Math.min(a, 9));
          card.style.pointerEvents = hidden ? 'none' : '';
          card.dataset.active = a === 0 ? 'true' : 'false';
          card.setAttribute('aria-hidden', a === 0 ? 'false' : 'true');
          var interactive = card.querySelectorAll('[data-ifc-link], [data-ifc-play]');
          Array.prototype.forEach.call(interactive, function (el) {
            el.tabIndex = a === 0 ? 0 : -1;
          });
        });

        // Never disable either arrow at the ends: navigation wraps forever.
        if (prev) prev.disabled = total < 2;
        if (next) next.disabled = total < 2;
        pauseAll(cards[active]);
      }

      function go(index) {
        var total = cards.length;
        if (!total) return;
        // Positive modulo makes -1 become the last video and total become 0.
        var target = ((index % total) + total) % total;
        if (target === active) return;
        active = target;
        render();
      }

      if (prev) prev.addEventListener('click', function () { go(active - 1); });
      if (next) next.addEventListener('click', function () { go(active + 1); });

      stage.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') { event.preventDefault(); go(active - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); go(active + 1); }
      });

      cards.forEach(function (card, i) {
        card.addEventListener('click', function (event) {
          if (i !== active) {
            event.preventDefault();
            event.stopPropagation();
            go(i);
          }
        }, true);

        var button = card.querySelector('[data-ifc-play]');
        var video = card.querySelector('[data-ifc-video]');
        if (button && video) {
          button.addEventListener('click', function () {
            if (video.paused) {
              pauseAll(card);
              video.muted = false;
              var promise = video.play();
              if (promise && promise.catch) {
                promise.catch(function () {
                  video.muted = true;
                  video.play();
                });
              }
              card.dataset.playing = 'true';
              button.setAttribute('aria-pressed', 'true');
              button.setAttribute('aria-label', 'Pause video');
            } else {
              video.pause();
              card.dataset.playing = 'false';
              button.setAttribute('aria-pressed', 'false');
              button.setAttribute('aria-label', 'Play video');
            }
          });
        }
      });

      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        startX = event.clientX;
        dragged = false;
        if (track.setPointerCapture && event.pointerId !== undefined) {
          try { track.setPointerCapture(event.pointerId); } catch (e) {}
        }
      });

      track.addEventListener('pointermove', function (event) {
        if (startX === null) return;
        if (Math.abs(event.clientX - startX) > 8) dragged = true;
      });

      track.addEventListener('pointerup', function (event) {
        if (startX === null) return;
        var delta = event.clientX - startX;
        startX = null;
        if (Math.abs(delta) > 40) go(active + (delta < 0 ? 1 : -1));
      });

      track.addEventListener('pointercancel', function () { startX = null; });
      // Keep the start point until pointerup/pointercancel so swipes can finish outside the track.

      track.addEventListener('click', function (event) {
        if (dragged) {
          event.preventDefault();
          event.stopPropagation();
          dragged = false;
        }
      }, true);

      root.addEventListener('shopify:block:select', function (event) {
        var index = cards.indexOf(event.target);
        if (index > -1) go(index);
      });

      render();
    }

    function initAll() {
      document.querySelectorAll('[data-ifc]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-faq-receipt"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var el = root.querySelector('[data-rcp-date]');
      if (!el) return;
      el.textContent = new Date()
        .toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
        .toUpperCase();
    }

    function initAll() {
      document.querySelectorAll('[data-rcp]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-main"]) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.pdpReady) return;
      root.dataset.pdpReady = 'true';

      var dataEl = root.querySelector('[data-pdp-variants]');
      var variants = [];
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (error) {
        variants = [];
      }

      var selects = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-option]'));
      var idInput = root.querySelector('[data-pdp-id]');
      var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-atc]'));
      var prices = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-price]'));
      var compares = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-compare]'));
      var badge = root.querySelector('[data-pdp-badge]');
      var percent = root.querySelector('[data-pdp-percent]');
      var titles = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-variant-title]'));
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
      var addLabel = root.dataset.addLabel;
      var soldLabel = root.dataset.soldLabel;

      function showImage(id) {
        var found = slides.some(function (slide) { return slide.dataset.slide === String(id); });
        if (!found) return;
        slides.forEach(function (slide) {
          slide.hidden = slide.dataset.slide !== String(id);
        });
        thumbs.forEach(function (thumb) {
          if (thumb.dataset.thumb === String(id)) {
            thumb.setAttribute('aria-current', 'true');
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
      }

      function findVariant() {
        if (!selects.length) return variants[0];
        var values = selects.map(function (select) { return select.value; });
        return variants.filter(function (variant) {
          return values.every(function (value, index) { return variant.options[index] === value; });
        })[0];
      }

      function setButtons(label, disabled) {
        buttons.forEach(function (button) {
          button.textContent = label;
          button.disabled = disabled;
        });
      }

      function update() {
        var variant = findVariant();
        if (!variant) {
          setButtons('Unavailable', true);
          return;
        }
        if (idInput) idInput.value = variant.id;
        prices.forEach(function (el) {
          el.textContent = variant.price;
          el.classList.toggle('is-sale', !!variant.compare);
        });
        compares.forEach(function (el) {
          if (variant.compare) {
            el.textContent = variant.compare;
            el.hidden = false;
          } else {
            el.hidden = true;
          }
        });
        if (badge) {
          badge.hidden = !variant.compare;
          if (percent) percent.textContent = variant.percent;
        }
        titles.forEach(function (el) { el.textContent = variant.title; });
        setButtons(variant.available ? addLabel : soldLabel, !variant.available);
        if (variant.image) showImage(variant.image);
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      selects.forEach(function (select) { select.addEventListener('change', update); });
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () { showImage(thumb.dataset.thumb); });
      });

      // Add to cart through Shopify's Ajax Cart API: no full-page reload.
      // The theme cart drawer is refreshed and opened as soon as Shopify responds.
      var productForm = root.querySelector('form[action*="/cart/add"]');
      if (productForm && !productForm.dataset.pdpAjaxBound) {
        productForm.dataset.pdpAjaxBound = 'true';
        var adding = false;

        productForm.addEventListener('submit', function (event) {
          event.preventDefault();
          if (adding) return;

          var activeVariant = findVariant();
          if (!activeVariant || !activeVariant.available) return;

          adding = true;
          var originalLabels = buttons.map(function (button) { return button.textContent; });
          buttons.forEach(function (button) {
            button.disabled = true;
            button.classList.add('is-loading');
            button.setAttribute('aria-busy', 'true');
            button.textContent = 'ADDING';
          });

          var formData = new FormData(productForm);
          formData.set('id', idInput ? idInput.value : activeVariant.id);
          formData.set('quantity', String(Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1)));
          formData.set('sections', 'cart-drawer,cart-icon-bubble');
          formData.set('sections_url', window.location.pathname);

          var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          fetch(rootPath + 'cart/add.js', {
            method: 'POST',
            body: formData,
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            credentials: 'same-origin',
            cache: 'no-store'
          })
          .then(function (response) {
            if (!response.ok) return response.json().then(function (error) { throw error; });
            return response.json();
          })
          .then(function (addedItem) {
            var drawer = document.querySelector('cart-drawer');
            var notification = document.querySelector('cart-notification');
            var target = drawer && typeof drawer.renderContents === 'function' ? drawer :
              (notification && typeof notification.renderContents === 'function' ? notification : null);

            if (target) {
              target.renderContents(addedItem);
              if (drawer && typeof drawer.open === 'function') drawer.open();
            } else {
              // Fallback for themes without an Ajax cart drawer.
              window.location.assign(rootPath + 'cart');
              return;
            }

            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item: addedItem } }));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            buttons.forEach(function (button) { button.textContent = 'ADDED'; });
            window.setTimeout(function () {
              buttons.forEach(function (button, index) {
                button.textContent = originalLabels[index] || addLabel;
                button.disabled = false;
                button.classList.remove('is-loading');
                button.removeAttribute('aria-busy');
              });
              adding = false;
            }, 650);
          })
          .catch(function (error) {
            console.error('BYAVENOR add to cart:', error);
            buttons.forEach(function (button, index) {
              button.textContent = originalLabels[index] || addLabel;
              button.disabled = false;
              button.classList.remove('is-loading');
              button.removeAttribute('aria-busy');
            });
            adding = false;
            var message = (error && (error.description || error.message)) || 'Please try again.';
            window.alert(message);
          });
        });
      }

      var qtyInput = root.querySelector('[data-pdp-qty-input]');
      Array.prototype.forEach.call(root.querySelectorAll('[data-pdp-qty]'), function (button) {
        button.addEventListener('click', function () {
          var next = (parseInt(qtyInput.value, 10) || 1) + parseInt(button.dataset.pdpQty, 10);
          qtyInput.value = Math.max(1, next);
        });
      });

      var checks = root.querySelector('[data-pdp-checks]');
      if (checks) {
        var groups = Array.prototype.slice.call(checks.querySelectorAll('[data-pdp-slide-group]'));
        var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (groups.length > 1 && !reduced) {
          var seconds = parseFloat(checks.dataset.interval) || 2.5;
          var index = 0;
          setInterval(function () {
            var current = groups[index];
            index = (index + 1) % groups.length;
            current.classList.add('is-leaving');
            current.classList.remove('is-active');
            groups[index].classList.remove('is-leaving');
            groups[index].classList.add('is-active');
            setTimeout(function () { current.classList.remove('is-leaving'); }, 520);
          }, seconds * 1000);
        }
      }

      var bar = root.querySelector('[data-pdp-bar]');
      var buy = root.querySelector('[data-pdp-buy]');
      if (bar && buy) {
        var check = function () {
          bar.classList.toggle('is-visible', buy.getBoundingClientRect().bottom < 0);
        };
        window.addEventListener('scroll', check, { passive: true });
        window.addEventListener('resize', check);
        check();
      }
    }

    function initAll() {
      document.querySelectorAll('[data-pdp]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function wire(root) {
      var prev = root.querySelector('[data-prc-prev]');
      var next = root.querySelector('[data-prc-next]');
      var track = root.querySelector('[data-prc-track]');
      if (!track) return;

      function update() {
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft >= max - 4;
      }

      function move(direction) {
        var card = track.querySelector('.prc__card');
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var amount = (card ? card.getBoundingClientRect().width : track.clientWidth) + gap;
        track.scrollBy({ left: direction * amount, behavior: 'smooth' });
      }

      if (!root.dataset.prcBound) {
        root.dataset.prcBound = 'true';
        if (prev) prev.addEventListener('click', function () { move(-1); });
        if (next) next.addEventListener('click', function () { move(1); });
        root.addEventListener('keydown', function (event) {
          var current = root.querySelector('[data-prc-track]');
          if (!current || event.target !== current) return;
          if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
          if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
        });
      }

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    function init(root) {
      if (root.dataset.prcReady) return;
      root.dataset.prcReady = 'true';

      var url = root.dataset.url;
      if (root.dataset.performed !== 'true' && url && window.fetch) {
        fetch(url)
          .then(function (response) { return response.ok ? response.text() : ''; })
          .then(function (html) {
            if (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var fresh = doc.querySelector('[data-prc-inner]');
              var current = root.querySelector('[data-prc-inner]');
              if (fresh && current && fresh.querySelector('.prc__card')) {
                current.replaceWith(fresh);
              }
            }
            wire(root);
          })
          .catch(function () { wire(root); });
      } else {
        wire(root);
      }
    }

    function initAll() {
      document.querySelectorAll('[data-prc]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.prvReady) return;
      var track = root.querySelector('[data-prv-track]');
      if (!track) return;
      root.dataset.prvReady = 'true';

      var prev = root.querySelector('[data-prv-prev]');
      var next = root.querySelector('[data-prv-next]');

      function move(direction) {
        var card = track.querySelector('.prv__card');
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var amount = (card ? card.getBoundingClientRect().width : track.clientWidth) + gap;
        var max = track.scrollWidth - track.clientWidth;
        var target = track.scrollLeft + direction * amount;
        if (direction > 0 && track.scrollLeft >= max - 4) target = 0;
        if (direction < 0 && track.scrollLeft <= 4) target = max;
        track.scrollTo({ left: target, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { move(-1); });
      if (next) next.addEventListener('click', function () { move(1); });

      track.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
      });
    }

    function initAll() {
      document.querySelectorAll('[data-prv]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-shipping-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var opts = { month: 'short', day: 'numeric' };

    function fmt(date) {
      return date.toLocaleDateString('en-US', opts);
    }

    function addDays(base, days, business) {
      var d = new Date(base.getTime());
      if (!business) {
        d.setDate(d.getDate() + days);
        return d;
      }
      var left = days;
      while (left > 0) {
        d.setDate(d.getDate() + 1);
        var day = d.getDay();
        if (day !== 0 && day !== 6) left -= 1;
      }
      return d;
    }

    function range(a, b) {
      if (a.getTime() === b.getTime()) return fmt(a);
      if (a.getMonth() === b.getMonth()) {
        return fmt(a) + ' – ' + b.getDate();
      }
      return fmt(a) + ' – ' + fmt(b);
    }

    function init(root) {
      if (root.dataset.pstReady) return;
      root.dataset.pstReady = 'true';

      var now = new Date();
      var business = root.dataset.business === 'true';
      var procMin = parseInt(root.dataset.processingMin, 10) || 0;
      var procMax = Math.max(procMin, parseInt(root.dataset.processingMax, 10) || 0);
      var transitMin = parseInt(root.dataset.transitMin, 10) || 0;
      var transitMax = Math.max(transitMin, parseInt(root.dataset.transitMax, 10) || 0);

      var ship = fmt(addDays(now, procMax, business));
      var delivery = range(
        addDays(now, procMin + transitMin, business),
        addDays(now, procMax + transitMax, business)
      );

      Array.prototype.forEach.call(root.querySelectorAll('[data-pst-ship]'), function (el) {
        el.textContent = ship;
      });
      var deliveryEl = root.querySelector('[data-pst-delivery]');
      if (deliveryEl) deliveryEl.textContent = delivery;

      var timeEl = root.querySelector('[data-pst-time]');
      function tick() {
        var current = new Date();
        var end = new Date(current.getTime());
        end.setHours(24, 0, 0, 0);
        var minutes = Math.max(0, Math.floor((end - current) / 60000));
        timeEl.textContent = Math.floor(minutes / 60) + ' Hrs. ' + (minutes % 60) + ' Min.';
      }
      if (timeEl) {
        tick();
        setInterval(tick, 30000);
      }
    }

    function initAll() {
      document.querySelectorAll('[data-pst]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
